export default __webpack_public_path__ + "static/media/default.a6143582.png";